module.exports = __webpack_public_path__ + "static/media/X6.6abdbaf9.png";